import { useCallback } from 'react'

import Flex from '@/elements/Flex'
import NotificationSettings from '@/components/NotificationSettings'
import { updateOrgMemberNotificationSettings, useGetOrgMemberNotificationsSettings } from '@/api/notifications'
import type { NotificationSettingResponse } from '@/api/types/Notification'
import toast from '@/utils/toast'

function MemberNotificationsPreferences({ organizationMemberId }: { organizationMemberId: string }) {
  const { data: orgMemberNotifications, isLoading, refetch } = useGetOrgMemberNotificationsSettings(organizationMemberId)

  const submitUpdateNotifications = useCallback(async (id: NotificationSettingResponse['id'], value: NotificationSettingResponse['value']) => {
    try {
      await updateOrgMemberNotificationSettings(organizationMemberId, id, value)
      toast.success('Notification updated')
    } catch {
      toast.error('Failed to update notification')
    }
    await refetch()
  }, [organizationMemberId, refetch])

  return (
    <Flex fraction={6} wfull hfull align='stretch'>
      <NotificationSettings
        loading={isLoading}
        notifications={orgMemberNotifications?.data || []}
        onSave={submitUpdateNotifications}
      />
    </Flex>
  )
}

export default MemberNotificationsPreferences
